import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '@shared/services/contentful.service';

@Component({
  selector: 'rav-contact-phone',
  templateUrl: './contact-phone.component.html',
  styleUrls: ['./contact-phone.component.scss']
})
export class ContactPhoneComponent implements OnInit {
  phoneDisplay: string;
  phoneValue: string;

  constructor(private contentful: ContentfulService) {}

  ngOnInit() {
    this.contentful.getContactInfo().then((contactInfo) => {
      this.phoneDisplay = contactInfo[0].fields.phoneDisplay;
      this.phoneValue = contactInfo[0].fields.phoneValue;
    });
  }
}
